var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPasswordShowIcon = function SvgPasswordShowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.01 8.027c.214.266.333.612.333.97s-.119.703-.332.97c-1.35 1.633-4.423 4.815-8.01 4.815-3.587 0-6.66-3.182-8.01-4.816a1.553 1.553 0 0 1-.332-.97c0-.357.119-.703.332-.969C3.34 6.393 6.414 3.211 10 3.211c3.587 0 6.66 3.182 8.01 4.816Z",
    stroke: "#34389F",
    strokeWidth: 1.631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 11.569a2.571 2.571 0 1 0 0-5.143 2.571 2.571 0 0 0 0 5.143Z",
    stroke: "#34389F",
    strokeWidth: 1.631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPasswordShowIcon;